import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRConfirmBulkSubmitModalViewModel from './OCRConfirmBulkSubmitModalViewModel'

/**
 * Confirm Bulk Submit Modal
 */
export default observer(function OCRConfirmBulkSubmitModal({
  vm,
}: {
  vm: OCRConfirmBulkSubmitModalViewModel
}) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.close}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_invite-people.svg')}
          />
          <ModalSheetContentTitle>
            You are about to submit{' '}
            {vm.ocrScopingJobBulkActionViewModel.bulkActionSelectedCount} jobs
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you submit you will no longer
            be able to make any more changes.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button type="primary" onClick={vm.confirm}>
            Submit
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
